import React from "react";
import Select from "react-select";

const WorkPreferenceSelect = ({ value, onChange }) => {
  const options = [
    { value: 'online', label: "Online" },
    { value: 'offline', label: "Offline" },
    { value: 'hybrid', label: "Hybrid" },
    { value: 'on-site', label: "On-Site" },
  ];

  const handleChange = (selectedOption) => {
    onChange(selectedOption ? { value: selectedOption.value, label: selectedOption.label } : null);
  };

  return (
    <Select
      options={options}
      placeholder="Select Work Preference"
      value={value ? options.find(option => option.value === value.value) || null : null}
      onChange={handleChange}
      isClearable
    />
  );
};

export default WorkPreferenceSelect;
